export default __webpack_public_path__ + "static/JessicaCoppet-814e41dda51368c918c03358aba087f7.svg";